/**
 * Sales reporting counts two kinds of sale: bookings ("jobs") and standalone
 * counter-sale/order invoices ("orders"). A business can run on either or both,
 * so the label adapts instead of hard-coding "jobs" and undercounting order-only
 * businesses.
 */

export type SalesUnit = 'jobs' | 'orders' | 'mixed';

export function salesUnitFor(bookingCount: number, orderCount: number): SalesUnit {
  if (bookingCount > 0 && orderCount > 0) return 'mixed';
  if (orderCount > 0) return 'orders';
  return 'jobs';
}

/** Tile/stat label for the total count of sales. */
export function salesCountLabel(unit: SalesUnit): string {
  if (unit === 'mixed') return 'Jobs & orders';
  if (unit === 'orders') return 'Total orders';
  return 'Total jobs';
}

/**
 * Average sale = total sales ÷ number of sales, counting bookings and orders
 * together so `avg × count` always reconciles with the headline total.
 */
export function averageSale(totalSales: number, bookingCount: number, orderCount: number): number {
  const count = bookingCount + orderCount;
  return count > 0 ? totalSales / count : 0;
}
